import type { Board } from "../board.ts";

let modal: HTMLElement | null = null;

export function closeTopic(): void {
  modal?.remove();
  modal = null;
}

// A big, readable view of a topic wall: the stance chart at full size + the
// publishable synthesis (headline + body) + safe aggregates. Opened from the
// "Ver cartelera" proximity button.
export function openTopic(board: Board, topicId: string): void {
  closeTopic();
  const t = board.topics.find((x) => x.id === topicId);
  if (!t) return;

  const overlay = document.createElement("div");
  overlay.className =
    "fixed inset-0 z-40 flex items-center justify-center bg-black/40 p-4";
  overlay.addEventListener("click", (e) => {
    if (e.target === overlay) closeTopic();
  });

  const card = document.createElement("div");
  card.className =
    "flex max-h-[90vh] w-full max-w-2xl flex-col gap-3 overflow-auto rounded-2xl border-2 border-black bg-white p-5 shadow-2xl";

  const head = document.createElement("div");
  head.className = "flex items-center gap-3";
  const h = document.createElement("h2");
  h.className = "text-xl font-bold";
  // "Lo que dicen N expertos consultados en <Tema>" (falls back gracefully
  // when the expert count isn't available).
  const n = t.expertCount;
  const headline = n != null
    ? `Lo que dicen ${n} ${
      n === 1 ? "experto consultado" : "expertos consultados"
    } en ${t.title}`
    : `Lo que dicen los expertos consultados en ${t.title}`;
  h.textContent = t.emoji ? `${t.emoji} ${headline}` : headline;
  const close = document.createElement("button");
  close.className =
    "ml-auto rounded-lg border-2 border-black px-3 py-1 font-bold";
  close.textContent = "Cerrar ✕";
  close.addEventListener("click", closeTopic);
  head.append(h, close);

  const img = document.createElement("img");
  img.src = `/assets/charts/${t.id}.png`;
  img.alt = `Posiciones de los expertos — ${t.title}`;
  img.className =
    "max-h-[55vh] w-full rounded-lg border border-black object-contain";

  const stats = document.createElement("div");
  stats.className = "text-xs opacity-60";
  const parts: string[] = [];
  if (t.expertCount != null) parts.push(`${t.expertCount} expertos`);
  if (t.questionsAnswered != null) {
    parts.push(`${t.questionsAnswered} preguntas`);
  }
  if (t.meanAgreement != null) {
    parts.push(`acuerdo ${Math.round(t.meanAgreement * 100)}%`);
  }
  stats.textContent = parts.join(" · ");

  const summary = document.createElement("p");
  summary.className = "whitespace-pre-line text-sm leading-relaxed";
  const text = (t.headline?.trim() ?? "") +
    (t.body?.trim() ? `\n\n${t.body.trim()}` : "");
  summary.textContent = text || "Contenido en preparación.";

  card.append(head, img, stats, summary);
  overlay.appendChild(card);
  document.body.appendChild(overlay);
  modal = overlay;
}
